// NotImplemented.js
//import React, {useEffect, useState, useRef} from 'react';
import { styled  } from '@mui/material/styles';
import { Box } from '@mui/system';
import TopViewControl from '../../common/TopViewControl';

const NotImpBox = styled(Box)({display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', });
const TitleBox = styled(Box)({fontSize:24, fontWeight:'bold', textAlign:'center', marginTop:20});
const MessageBox = styled(Box)({fontSize:16, textAlign:'center', marginTop:10});

export default function NotImplemented({
    menu, parentMenu
}) {
    return(
        <TopViewControl parentMenu={parentMenu}>
            <NotImpBox>
                <TitleBox>{menu.menuName} Not Implemented ({menu.menuUrl}/{menu.menuId})</TitleBox>
                <MessageBox>This page is not implemented yet.</MessageBox>
            </NotImpBox>
        </TopViewControl>
    );
}
